import ResidentialAddress from "./ResidentialAddress";

export default ResidentialAddress;
